// {signature}

const bscript = require('../../script')

function check (script) {
  const chunks = bscript.decompile(script)

  return chunks.length === 1 &&
    bscript.isCanonicalScriptSignature(chunks[0])
}
check.toJSON = function () { return 'pubKey input' }

module.exports = {
  check: check
}



//////////////////
// WEBPACK FOOTER
// ./~/bitcoinjs-lib/src/templates/pubkey/input.js
// module id = 381
// module chunks = 0